// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectIcon_container__P0BWd"};